import { apiDate, optional, optionalString, string, zodLess } from '@kaiizen/zod-less';
import { optionalApiDate, optionalMetadataSchema } from '../schemaLib';

export const ApiOrgContractorBaseSchema = zodLess({
  id: string,
  orgId: string,
  name: string,
  // First-class contact fields — they drive model business logic (contractor links, claim
  // delivery). customerMetadata is free-form, purely informational keys (e.g. vendorId).
  email: optionalString,
  phoneNumber: optionalString,
  customerMetadata: optionalMetadataSchema,
  contractorOrgId: optionalString,
  createdAt: apiDate,
  updatedAt: apiDate,
  archivedAt: optionalApiDate,
  trades: optional([string]),
});
